/**
 * EnlaceAlAsiento.tsx — el número de asiento, que lleva al diario.
 *
 * ══ ▶▶ LLEVA TRES DATOS, Y EL ÚNICO OBVIO ES EL QUE NO BASTA ═══════════
 *
 * El diario abre en el mes en curso y filtra por año y mes. Un enlace que
 * mandara sólo el número abriría la pantalla en setiembre para un asiento de
 * marzo: no fallaría nada, no habría error, y la persona se quedaría buscando
 * una fila que está a seis meses de ahí. Por eso `/por-pagar` tuvo su número
 * SIN enlace durante dos entregas, con el motivo escrito al lado.
 *
 * Quien enseña un asiento sabe de qué fecha es, así que la manda.
 *
 * ▶ Y EXISTE COMO COMPONENTE, no como tres copias. Cuando esto vivía suelto en
 * `Documentos.tsx`, `Facturas.tsx` tenía su propia versión —`<Link to="/diario">`
 * pelado— que hacía exactamente el daño de arriba. Dos sitios que hacen lo
 * mismo y uno se quedó atrás es la falla que más veces ha cobrado esta casa.
 */
import { Link } from 'react-router-dom';

export function EnlaceAlAsiento(
  { asiento, fecha }: { asiento: string | number; fecha: string },
) {
  /* ▶ `fecha` es texto `YYYY-MM-DD` y se parte con `slice`, NUNCA con
     `new Date`: en cualquier huso al oeste de Greenwich `new Date('2026-03-01')`
     cae el 28 de febrero, y el enlace abriría el mes anterior. Es el mismo
     cuidado que el diario tiene escrito sobre su propia columna de fecha, y
     acá el síntoma sería peor: un enlace que falla sólo el día 1. */
  const anio = fecha.slice(0, 4);
  const mes = String(Number(fecha.slice(5, 7)));

  /* ▶ La RUTA aparte de la PREGUNTA, y no es estilo. Escrito como una sola
     cadena armada al vuelo, el guardián 14 no puede saber a qué pantalla lleva
     — y lo denunció. Lo que se arma acá es la pregunta; la ruta es `/diario` y
     no depende de nada. */
  return (
    <Link
      className="enlace-asiento mono"
      to={{ pathname: '/diario', search: `?anio=${anio}&mes=${mes}&asiento=${asiento}` }}
    >
      #{asiento}
    </Link>
  );
}
